import { FileUploadDataSchema } from "@qw/ui";
import { z } from "zod";

export const ProductFormSchema = z
  .object({
    name: z.string(),
    workflow: z.string(),
    files: z.array(FileUploadDataSchema),
    carrierId: z.string().optional(),
    lineOfBusinessIds: z.array(z.string()).optional().default([]),
    enabled: z.boolean().optional(),
    marketType: z.enum(["bindingAuthority", "brokerage"]).optional(),
    grossCommission: z.number().min(0).max(99.99).nullable().optional(),
  })
  .refine(
    (data) => {
      // If enabled, require carrier, LOB, and market type
      if (data.enabled) {
        return !!(data.carrierId && data.lineOfBusinessIds && data.lineOfBusinessIds.length > 0 && data.marketType);
      }
      return true;
    },
    {
      message: "Carrier, Line of Business, and Market Type are required for enabled products",
      path: ["enabled"],
    }
  );

export type ProductFormValues = z.infer<typeof ProductFormSchema>;
